import { AppStateProvider } from 'src/app/providers/app-state.provider';
import { Component, OnInit } from '@angular/core';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { ApiService } from 'src/app/services/api.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';


@Component({
  standalone: false,
  selector: 'app-credit-score-ta',
  templateUrl: './credit-score.component.html',
  styleUrls: ['./credit-score.component.scss'],
  // encapsulation: ViewEncapsulation.None


})
export class CreditScoreComponent implements OnInit {
  meetingNav: { index: string; name: string; link: string; }[];
  token: string;
  tenantId: string;
  url: string;
  tenantDetail: any;
  tenantUsers: any[];
  tenantUser: any[];
  closeResult = '';
  disbursePoints = 0;
  page = 1;
  pageSize = 10;
  showPagination: boolean;
  pipe: any;
  validPoints: any;
  maxValue: boolean;

  constructor(private apiService: ApiService, private modalService: NgbModal,
    private appStateSrv: AppStateProvider, private router: Router, private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.meetingNav = [
      {
        index: "3",
        name: "credit-score",
        link: '/credit/ta'
      }
    ];
    const route = {
      index: "3",
      name: "credit-score",
      link: '/credits'
    };
    this.appStateSrv.setSideNavState(route);
    this.getApiauthorizationToken();
  }

  getApiauthorizationToken() {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {
      this.tenantId = localStorage.getItem(AppConstant.localStorage.tenantId)
      this.getTenantDetails();
      this.getTenantUser();
    }
  }

  private getTenantDetails() {
    this.url = '';
    this.url = APIs.getTenantCredit;
    const paramObj = {
      TenantId: this.tenantId
    };
    this.apiService.get(this.url, paramObj).subscribe(response => {
      // if (response && response.isValid && response.list.length > 0) {
      this.tenantDetail = response.list;
      console.log('detail', this.tenantDetail);

      // }
      // else {
      //   //handle null values here
      //   alert(response.errorMsg)
      // }
    },
      error => {
        //handle errors here
        // alert(error);
      })
  }

  private getTenantUser() {
    this.url = '';
    this.url = APIs.getTenantUser;
    const paramObj = {
      TenantId: this.tenantId
    };
    this.apiService.get(this.url, paramObj).subscribe(response => {
      if (response && response.isValid && response.list.length > 0) {
        this.tenantUsers = response.list;
        this.refreshPagination(1);
      }
      else {
        //handle null values here;
        // alert(response.errorMsg)

      }
    },
      error => {
        //handle errors here;
        // alert(error)
      })
  }

  generateInitials(name: string) {
    if (name)
      return (name.split(' ')[0].charAt(0).toUpperCase() + " " + (name.split(' ')[1] !== undefined ? name.split(' ')[1].charAt(0).toUpperCase() : ''));
    else
      return '';
  }

  handlePageChange(event) {
    this.page = event;
    // this.itemsDisplayed= this.members.list.length-10*this.page;
  }

  getPoints(pointArray: [], creditPointType: number) {
    let totalCreditPoints = 0;
    pointArray.find((findCredit: any) => {
      if (findCredit.creditPointTypeId === creditPointType) {
        totalCreditPoints = findCredit.totalCreditPoints
      }
    });
    return totalCreditPoints;
  }

  getTotalCredit(creditArray: any) {
    let totalCredit = 0;
    if (creditArray !== undefined && creditArray.length > 0) {
      creditArray.forEach((creditResult: any) => {
        totalCredit = totalCredit + creditResult.totalCreditPoints
      });
    }
    return totalCredit;
  }

  getTenantCredit(pointArray: any, type: string, creditCalculate: string) {
    let creditPoints = 0;
    let usedPoints = 0;
    if (pointArray !== undefined && pointArray.length > 0) {
      pointArray.forEach((creditPointValue: any) => {
        if (creditCalculate === 'total') {
          if (type === 'reserved') {
            creditPoints = creditPoints + creditPointValue.reservedCreditPoints;
          } else {
            creditPoints = creditPoints + creditPointValue.poolCreditPoints;
          }
        } else {
          if (type === 'reserved') {
            usedPoints = usedPoints + (creditPointValue.reservedCreditPoints - creditPointValue.usedReservedCreditPoints);
          } else {
            usedPoints = usedPoints + (creditPointValue.poolCreditPoints - creditPointValue.usedPoolCreditPoints);
          }
        }
      });
    }
    if (creditCalculate === 'total') {
      return creditPoints;
    } else {
      this.validPoints = usedPoints;
      return usedPoints;
    }
  }

  updateCreditPointAccess(userId: number, isAccess: boolean) {
    console.log(userId, isAccess);
    if (userId && userId !== undefined) {
      this.url = '';
      this.url = APIs.updateUserCreditAccess;
      this.url = this.url + "?id=" + userId + "&isCreditPointAccess=" + isAccess;
      const paramObj = {
        TenantId: this.tenantId,
        userId: isAccess
      };
      this.apiService.put(this.url, '', null, paramObj).subscribe(response => {
        if (response.isValid && response.successMsg) {
          this.getTenantUser();
        } else {
          //handle error values here. check for 'errorMsg'
          // alert('here' + response.errorMsg)
        }
      },
        error => {
          // handle api error here
          // alert(error)
        });
    }
  }

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'modal-class', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getAvailableForDisburse(totalCredit: number, used: number) {
    console.log(totalCredit, used)
    if (totalCredit && used && totalCredit >= used) {
      return totalCredit - used
    }
    return 'NA';
  }

  disburse() {
    if (this.disbursePoints <= 0 || this.disbursePoints == null) {
      this.appStateSrv.showToast('You can not disburse the 0 points');
      return;
    }
    this.url = '';
    this.url = APIs.disbursePoint;
    const requestBody = {
      tenantId: parseInt(this.tenantId),
      disbursedCreditPoints: this.disbursePoints
    };
    this.apiService.post(this.url, requestBody, '').subscribe(Response => {
      if (Response && Response.isValid) {
        //display success Message here
        // alert('Successfully Disbursed');
        this.appStateSrv.showToast('Successfully Disbursed');

        this.clearSearch();
        this.getTenantDetails();
        // } else {
        //   //handle error values here. check for 'errorMsg'
        //   alert(Response.errorMsg);
        //   this.appStateSrv.showToast('You can not disburse the 0 points');

      }
    },
      error => {
        // handle api error here
        // alert(error)
      })
  }
  clearSearch() {
    this.disbursePoints = 0;
  }
  refreshPagination(e) {
    console.log('pagination clicked');

    this.page = e;
    // this.tenantUser = this.tenantUsers.map(
    //   (tenant: any, i: any) => ({ id: i + 1, ...tenant })).slice(
    //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.tenantUser = this.tenantUsers.slice(0, this.tenantUsers.length < 10 ? this.tenantUsers.length : (this.page - 1) * this.pageSize + this.pageSize)
    console.log('tenantUser', this.tenantUser, 'tenantUsers', this.tenantUsers);
    this.showPagination = true;

  }

  RequestCreditpoints() {
    this.url = '';
    this.url = APIs.RequestCreditPoints;
    tenantId: parseInt(this.tenantId);
    const header = {
      Authorization: this.token
    }
    this.url = this.url + "?TenantId=" + this.tenantId
    this.apiService.post(this.url, '', header).subscribe(Response => {
      console.log('RequestCredits', Response);
      if (Response && Response.isValid) {
        //display success Message here
        //alert(Response.SuccessMsg);
        this.appStateSrv.showToast(Response.SuccessMsg);
      } else {
        //handle error values here. check for 'errorMsg'
        // alert(Response.errorMsg);
      }
    },
      error => {
        // handle api error here
        // alert(error)
      })
  }


  getUsedPoolCreditPoints(pointArray: []) {
    let totalUsedPoolCreditPoints = 0;
    if (pointArray !== undefined && pointArray.length > 0) {
      for (var i = 0; i < pointArray.length; i++) {
        pointArray.find((findCredit: any) => {
          if (findCredit.creditPointTypeId === 1 || findCredit.creditPointTypeId === 2) {
            totalUsedPoolCreditPoints = totalUsedPoolCreditPoints + findCredit.usedPoolCreditPoints
          }
        });
      }
      return totalUsedPoolCreditPoints / 2;
    }
  }

  getUsedResrvedCreditPoints(pointArray: []) {
    let totalUsedResrvedCreditPoints = 0;
    if (pointArray !== undefined && pointArray.length > 0) {
      for (var i = 0; i < pointArray.length; i++) {
        pointArray.find((findCredit: any) => {
          if (findCredit.creditPointTypeId === 1 || findCredit.creditPointTypeId === 2) {
            totalUsedResrvedCreditPoints = totalUsedResrvedCreditPoints + findCredit.usedReservedCreditPoints
          }
        });
      }
      return totalUsedResrvedCreditPoints / 2;
    }
  }

  CreditUsageReport() {

    const queryParams = {
      type: 0,
      fromDate: this.datePipe.transform(new Date(), 'MM/dd/yyyy'),
      toDate: this.datePipe.transform(new Date(), 'MM/dd/yyyy'),
      select: null,
      UsageTypeId: 0,
    };

    console.log('queryParams', queryParams);
    localStorage.setItem('reportQuery', JSON.stringify(queryParams));
    this.router.navigate(['/reports']);
  }

  onKeypressEvent(event: any) {
    if (event.target.value > this.validPoints || event.target.value == null || event.target.value == 0) {
      console.log(event.target.value);
      this.appStateSrv.showToast('Insufficient balance in disbursed credit points');
      this.maxValue = false;
      return;
    }
    else {
      this.maxValue = true;

    }
  }
}
